export default __webpack_public_path__ + "static/media/mask-group-398@3x.6e381d30.png";